import React from 'react'

const Heading = ({text}) => {
    return (
        <h1 className = 'text-center font-normal md:text-xl inline-block text-black p-3'>{text}</h1>
    )
}

export default Heading
